import { fitWithin, photoProblem } from './lib/list.js';

// Phone photos are 12 MP+; a product card needs far less. Shrink to 1600 px on the long edge and
// re-encode (WebP keeps transparency; JPEG where the browser can't write WebP) before upload.
const MAX_EDGE = 1600;

async function encode(canvas: HTMLCanvasElement, type: string): Promise<Blob | null> {
  return new Promise((resolve) => canvas.toBlob(resolve, type, 0.85));
}

/** A file ready for `uploadProductImage`, or an Error with a message people can act on. */
export async function prepareProductPhoto(file: File): Promise<Blob> {
  const first = photoProblem(file);
  if (first) throw new Error(first);
  let out: Blob = file;
  try {
    const bmp = await createImageBitmap(file);
    const { w, h } = fitWithin(bmp.width, bmp.height, MAX_EDGE);
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('no 2d context');
    ctx.drawImage(bmp, 0, 0, w, h);
    bmp.close();
    const webp = await encode(canvas, 'image/webp');
    const blob = webp && webp.type === 'image/webp' ? webp : await encode(canvas, 'image/jpeg');
    if (blob) out = blob;
  } catch {
    /* the browser can't decode it: send the original if the API accepts it */
  }
  const problem = photoProblem(out, { converted: true });
  if (problem) throw new Error(problem);
  return out;
}

/** The multipart body the API expects (field `image`). */
export function photoForm(blob: Blob): FormData {
  const form = new FormData();
  const ext = blob.type === 'image/png' ? 'png' : blob.type === 'image/webp' ? 'webp' : 'jpg';
  form.append('image', blob, `product.${ext}`);
  return form;
}
